<template>
  <div id="exhpredictionEdit">
    
    <div class="main-container" v-loading="this.loading" element-loading-text="加载中">
      <!--提交提醒-->
      <div class="notice-bar" >
        <i class="el-icon-info"></i>
        <span>提示：
          <br>1、报名信息填写过程中，您需要准备：图片或单页pdf的营业执照、开票信息、企业logo图片及企业简介、2-15个产品介绍（产品图片及简介）
          <br>2、请准确填报企业参展展位需求意向，将作为展位选择范围的参考依据。
          <br>3、完成所有信息填写并保存后，请点击页面最下方提交按钮提交报名信息。</span>
      </div>
      <!--审核状态-->
      <div id="remark" v-if="baseInforForm.sjzt == '04'">
        <el-row>
          <el-col :span="1" style="text-align: center">
            <i class="icon-alarm"></i>&nbsp;</el-col>
          <el-col :span="5" style="text-align: left">上次审核状态：已驳回</el-col>
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="15" style="text-align: left">审核意见：
            <span v-text="baseInforForm.reserve1"></span>
          </el-col>
        </el-row>
      </div>
      <el-collapse v-model="activeNames">
        <el-collapse-item name="1">
          <template slot="title">
           <i class="collapseicon el-icon-document"></i> 企业基本信息
          </template>
          <div id="inforView" class="pt15" >
            <baseInfo ref="baseInfo" v-on:getLoading="getLoading" v-on:getbaseInforData="getbaseInforData" v-on:getQyid="getQyid" v-on:getActive="getActive" v-bind:qyid="qyid"></baseInfo>
          </div>
        </el-collapse-item>
        <el-collapse-item name="2">
          <template slot="title">
            <i class="collapseicon el-icon-printer"></i> 企业开票信息
          </template>
          <div id="kpxxView" class="pt15" >
            <kpxx ref="kpxx" v-on:getLoading="getLoading" v-on:getActive="getActive" v-bind:qyid="qyid"></kpxx>
          </div>
        </el-collapse-item>
        <el-collapse-item name="3">
          <template slot="title">
            <i class="collapseicon el-icon-edit-outline"></i> 企业问卷调查
          </template>
          <div id="wjdcView" class="pt15">
            <wjdc ref="wjdc" v-on:getLoading="getLoading" v-on:getActive="getActive" v-bind:qyid="qyid"></wjdc>
          </div>
        </el-collapse-item>
        
        <el-collapse-item name="4">
          <template slot="title">
            <i class="collapseicon el-icon-edit-outline"></i> 企业问卷调查(二)
          </template>
          <div id="wjdc2View" class="pt15" >
            <wjdc2 ref="wjdc2" v-on:getLoading="getLoading" v-on:getActive="getActive" v-bind:qyid="qyid"></wjdc2>
          </div>
        </el-collapse-item>
        
        <el-collapse-item name="5">
          <template slot="title">
            <i class="collapseicon el-icon-setting"></i> 企业和产品介绍
          </template>
          <div id="cpjsView" class="pt15" >
            <cpjs ref="cpjs" v-on:getLoading="getLoading" v-on:getActive="getActive" v-bind:qyid="qyid"></cpjs>
          </div>
        </el-collapse-item>

        <el-collapse-item name="6">
          <template slot="title">
            <i class="collapseicon el-icon-star-on"></i> 企业参展展位需求意向
          </template>
          <div id="xqyxView" class="pt15" >
            <xqyx ref="xqyx" v-on:getLoading="getLoading" v-on:getActive="getActive" v-bind:qyid="qyid"></xqyx>
          </div>
        </el-collapse-item>
      </el-collapse>
      
      <el-row class="buttonSubmit" v-if="this.userType == 'ZSYH'">
        <el-col :span="24">
          <el-button type="primary" icon="el-icon-check" size="small" @click="back()" 
          style="width:120px; height: 40px;">返回</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import baseInfo from '@/views/exhibition/prediction/exhprediction/exhpredictionEdit/BaseInfo2'
import kpxx from '@/views/exhibition/prediction/exhprediction/exhpredictionEdit/Kpxx2'
import wjdc from '@/views/exhibition/prediction/exhprediction/exhpredictionEdit/Wjdc'
import wjdc2 from '@/views/exhibition/prediction/exhprediction/exhpredictionEdit/Wjdc2'
import cpjs from '@/views/exhibition/prediction/exhprediction/exhpredictionEdit/Cpjs'
import xqyx from '@/views/exhibition/prediction/exhprediction/exhpredictionEdit/Xqyx'

export default {
  components: {
    baseInfo,
    kpxx,
    wjdc,
    wjdc2,
    cpjs,
    xqyx
  },
  name: "exhpredictionEdit",
  data() {
    return {
      //当前用户
      currentUser: this.CONSTANT.currentUser,
      userType: this.CONSTANT.currentUser.deptid,
      //显示加载中样
      loading: false,
      //企业id
      qyid: "",
      //进度条
      active: 0,
      baseInforForm:{},
      activeNames:['6']
    };
  },
 
  created: function() {
    //获取qyid
   if (this.userType == "ZSYH") {
      //展商
      this.doSearchQyidByUserid(this.currentUser.userid);
    } else {
      //管理员
      //this.qyid = this.$route.query.id;
      this.doSearchQyidByUserid(this.$route.query.id);
    }
  },
  methods: {
    //通过userid查询qyid
    doSearchQyidByUserid: function(userid){
      let vm = this;
      let params={
        userid:userid,
        deleteFlag: "N"
      }
      vm.$axios.post("/qyjbxx/list", params).then(
        function(res) {
          if (res.data.result.length > 0) {
            vm.qyid = res.data.result[0].qyid;
          }else{
            vm.qyid = 'newInsert'
            this.activeNames = ['1']
          }
        }.bind(vm),
        function(error) {
          console.log(error);
        }
      );
    },

    //add by yushch 20220929
    getLoading(loading){
      this.loading = loading;
    },
    getbaseInforData(data){
      this.baseInforForm = data;
    },
    getQyid(qyid){
      this.qyid = qyid;
    },
    getActive(active){
      this.active = active;
    },

    //提交-校验信息填写完整
    submit: function(){
      let vm = this;
      vm.loading = true;
      vm.$axios.get("/qyjbxx/checkInfoComplete/" + vm.qyid).then(
        function(res) {
          if (res.data.code == "00000000") {
            vm.loading = false;
            this.$router.push({
              name: "exhpredictionConfirm",
              query: { userid: this.currentUser.userid, type: "BJ" }
            });
          }else if (res.data.code == "99999999") {
            var msg = res.data.msg;
            vm.$alert(
              '请先保存:<Strong style="color:#000">' +
                msg +
                "</Strong> 信息后再提交！",
              "提示",
              { dangerouslyUseHTMLString: true }
            );
            vm.loading = false;
          } else {
            vm.loading = false;
            vm.$message.error(res.data.msg);
          }
        }.bind(vm),
        function(error) {
          console.log(error);
        }
      );
    },

    back: function(){
       this.$router.push({
        name: 'exhibitorWeb'
      });
    }
  }
};
</script>

<style lang="scss">
#exhpredictionEdit {
 
  .mb5 {
    margin-bottom: 5px;
  }
  
  .el-card__body {
    padding: 10px 0px 10px 0px;
  }
  .el-message {
    z-index: 10005 !important;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
  .el-dialog {
    width: 45%;
  }
  .el-button--small {
    padding: 9px 9px;
  }
  .yxLabel {
    text-align: right;
    font-size: 14px;
    color: #606266;
    line-height: 40px;
    padding: 0 12px 0 0;
    box-sizing: border-box;
    font-weight: 700;
    max-width: 100%;
    margin-bottom: 5px;
  }
  
  #tagCheckbox .el-checkbox__label {
    padding-left: 5px;
    font-size: 10px;
  }
  #remark {
    line-height: 31px;
    padding: 5px 15px;
    border: 1px solid #e40613;
    border-radius: 5px;
    color: #e40613;
    margin-bottom: 10px;
    margin-top: 10px;
    font-size: 16px;
    font-weight: bold;
  }
  #remark i.icon-alarm {
    width: 28px;
    height: 25px;
    display: inline-block;
    margin-bottom: -5px;
    background: url("/static/images/prediction/alarm.png") no-repeat;
    background-size: cover;
  }
  
  .card_title_font{
    line-height: 40px;
  }
  .clearfix{
    height: 40px;
  }
  .notice-bar{
    color: #409eff;
    line-height: 40px;
  }
  .collapseicon{
    margin :0 10px 0 10px
  }
  
}
</style>



// WEBPACK FOOTER //
// src/views/exhibition/prediction/exhprediction/ExhpredictionEdit2.vue